export const ACTION_PLAN_EVENT_OPEN = 'app:actionPlan:open'
export const ACTION_PLAN_EVENT_OPEN_FORM = 'app:actionPlan:openForm'
export const TEMPLATES = {
  LIST_ACTION_PLANS: 'listActionPlans',
  FORM_ACTION_PLANS: 'formActionPlans',
}
